import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "./firebase";
import "./style.css";
import "./production-polish.css";
import Login from "./components/Login";
import UsernameSetup from "./components/UsernameSetup";
import Chat from "./components/Chat";

function App() {
  const [user, loading] = useAuthState(auth);
  const [profileReady, setProfileReady] = useState(false);
  const [hasProfile, setHasProfile] = useState(false);

  useEffect(() => {
    let active = true;
    if (!user) {
      setProfileReady(false);
      setHasProfile(false);
      return undefined;
    }
    getDoc(doc(db, "users", user.uid))
      .then((snap) => {
        if (!active) return;
        const data = snap.exists() ? snap.data() : {};
        setHasProfile(Boolean(data.displayName && data.displayName.trim()));
        setProfileReady(true);
      })
      .catch((error) => {
        console.error("Could not load profile", error);
        if (active) setProfileReady(true);
      });
    return () => {
      active = false;
    };
  }, [user]);

  if (loading || (user && !profileReady)) {
    return (
      <div className="app-loading" style={{ "--pen-loading-accent": "#5b8def" }}>
        <span className="loading-mark">✒</span>
        <span>Opening Pen Messenger</span>
      </div>
    );
  }

  let homeElement = <Login />;
  if (user) {
    homeElement = hasProfile ? <Navigate to="/chat" replace /> : <Navigate to="/username" replace />;
  }

  let usernameElement = <Navigate to="/" replace />;
  if (user) {
    usernameElement = hasProfile ? <Navigate to="/chat" replace /> : <UsernameSetup />;
  }

  let chatElement = <Navigate to="/" replace />;
  if (user) {
    chatElement = hasProfile ? <Chat /> : <Navigate to="/username" replace />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={homeElement} />
        <Route path="/username" element={usernameElement} />
        <Route path="/chat" element={chatElement} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
